import { createContext, useContext, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import io from "socket.io-client";
import { apiUrl } from "../config/apiUrl";
import { saveUnReadNotification } from "../store/common/commonSlice";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const { isLogin, access_token } = useSelector((state) => state.authReducer);
  const { unreadNotification } = useSelector((state) => state.commonReducer);
  const socketRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLogin) {
      socketRef.current = io(apiUrl, {
        transports: ["websocket"],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        randomizationFactor: 0,
        auth: { token: access_token },
      });
    }
    return () => {
      socketRef.current?.disconnect();
    };
  }, [isLogin, access_token]);
  useEffect(() => {
    if (socketRef.current) {
      socketRef.current?.on("new-notification", ({ notification }) => {
        const totalCount = unreadNotification + 1;
        dispatch(saveUnReadNotification(totalCount));
      });
    }

    return () => {
      socketRef.current?.off("new-notification");
      socketRef.current?.off("unread");
    };
  }, [unreadNotification, socketRef.current]);
  return (
    <WebSocketContext.Provider value={socketRef}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
